import { render, staticRenderFns } from "./UnsavedChangesAlert.vue?vue&type=template&id=6ac0dbdb&scoped=true&"
import script from "./UnsavedChangesAlert.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesAlert.vue?vue&type=script&lang=js&"
import style0 from "./UnsavedChangesAlert.vue?vue&type=style&index=0&id=6ac0dbdb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac0dbdb",
  null
  
)

export default component.exports